module.exports = __webpack_public_path__ + "img/village.ca64ee98.svg";